import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";

@Component({
  selector: "group",
  template: `
    <div [class]="'fieldGroup ' + field.className">
      <kreform-field
        *ngFor="let f of field.fieldGroup"
        [field]="f"
      ></kreform-field>
      <ng-content></ng-content>
    </div>
  `,
  host: {
    "[class]": 'field.className || ""'
  }
})
export class KreFormFieldGroup extends FieldType {}
